import { mapGetters } from 'vuex';

export default {
    name: 'valuationCard',
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['viewport', 'glb']),
    },
};
